import React, { Suspense, useCallback, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { usePublicRoutes } from "./router.link";

import PosLayout from "./posLayout";
import AuthPages from "./authPages";
import HeaderLayouts from "./headerLayout";
import { useTranslation } from "react-i18next";

// MUI
import WifiOffIcon from '@mui/icons-material/WifiOff';

// custom components
import Display from "../core/common/display/display";
import PageLoader from "../core/loader";

// utils
import apiClient from "../utils/apiClient";

const AllRoutes = () => {
  const { publicRoutes, posRoutes, pagesRoute } = usePublicRoutes();
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.top) {
      window.top.postMessage({ type: 'POS_READY' }, '*');
    }
  }, []);

  const handleTokenExpiration = useCallback(() => {
    // Clear token and user data
    sessionStorage.removeItem("token");

    // Redirect to login page
    navigate("/signin", { replace: true });
  }, [navigate]);

  useEffect(() => {
    if (location.pathname.startsWith("/customer-display")) {
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      if (location.pathname !== "/signin") {
        navigate("/signin", { replace: true });
      }
      return;
    }

    const checkAuth = async () => {
      try {
        await apiClient.get("/me");
      } catch (error) {
        const status = error?.response?.status;

        if (status === 401) {
          console.warn("Session expired. Redirecting to sign in...");
          handleTokenExpiration();
        } else {
          console.error("Authentication check failed:", error);
          // Optional: navigate elsewhere or show error
          navigate("/signin", { replace: true });
        }
      }
    };
    checkAuth();
  }, [handleTokenExpiration, location.pathname, navigate]);

  useEffect(() => {
    const handleOffline = () => setOpen(true);
    const handleOnline = () => setOpen(false);

    if (navigator.onLine === false) {
      setOpen(true);
    }

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  const handleClose = (event, reason) => {
    event?.preventDefault();
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <div>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route element={<HeaderLayouts />}>
            {publicRoutes.map((route, id) => (
              <Route path={route.path} element={route.element} key={id} />
            ))}
          </Route>
          <Route element={<PosLayout />}>
            {posRoutes.map((route, id) => (
              <Route path={route.path} element={route.element} key={id} />
            ))}
          </Route>
          <Route element={<AuthPages />}>
            {pagesRoute.map((route, id) => (
              <Route path={route.path} element={route.element} key={id} />
            ))}
          </Route>
        </Routes>
      </Suspense>
      <Display type='info' icon={<WifiOffIcon />} open={open} message={t("noConnexion")} handleClose={handleClose} />
    </div>
  );
};
export default AllRoutes;
